const FilterFields = [
  {
    label: "Company",
    name: "id",
    All: true,
  },
  {
    label: "Site",
    name: "id",
  },
  {
    label: "Plan",
    name: "pid",
  },
];

export default FilterFields;
